import { BrandConfig } from './types';
import { gorampeBrand } from './profiles/gorampe';
import { accesElevationBrand } from './profiles/acces-elevation';

// VITE_BRAND env var at build time selects profile.
// Default = gorampe if not set.
const BRAND_KEY = (import.meta.env.VITE_BRAND ?? 'gorampe') as 'gorampe' | 'acces-elevation';

const PROFILES: Record<string, BrandConfig> = {
  gorampe: gorampeBrand,
  'acces-elevation': accesElevationBrand,
};

export const brand: BrandConfig = PROFILES[BRAND_KEY] ?? gorampeBrand;

export type { BrandConfig } from './types';
